import React from 'react';
import convierte from '../../../images/convierte.png';
import Button from '../../elements/buttons/Button';

const Convierte = () =>(
    <>
        <section className="convierteSection">
            <div className="wrap">
                <figure>  
                    <img src={convierte} alt="" title="" />
                </figure>
                <div className="convierteSection__caption">
                    <h3 className="titles">¡Convierte en smart tu TV!</h3>
                    <p>¿Tienes un televisor que no es smart? No te preocupes, con cualquiera de estos dispositivos puedes hacerlo. </p>
                    <div>
                        <Button copy="Descubre cómo" link="/" className="button-primary" />
                    </div>
                </div>
                 
            </div>
        </section>
    </>
)

export default Convierte;